import { useNavigate, useParams } from "react-router-dom";
import MenuItem from "../MenuItem/MenuItem";
import "./Subcategory.scss";
import { useTranslation } from "react-i18next";

export default function Subcategory({
  id,
  setShowAllId,
  name,
  products,
  isActive,
  setShowMessage,
  cart,
  setCart,
  isCombo,
  setActive
}) {
  const { categoryId, subcategoryId } = useParams("categoryId");
  const navigate = useNavigate();
  const { t } = useTranslation();
  const deviceType = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
    ? "mobile"
    : "desktop";

  return (
    <div className="main-subcategory">
      <div className="content">
        <div className="title-cta">
          <div className="title">
            <p>{name}</p>
          </div>
        </div>
        <div className="items">
          {products.slice(0, deviceType === "desktop" ? 4 : 2).map((item) => {
            return (
              <MenuItem
                isActive={isActive}
                product={item}
                id={item.id}
                cart={cart}
                setCart={setCart}
                setShowMessage={setShowMessage}
                isCombo={isCombo}
              ></MenuItem>
            );
          })}
        </div>
        <div className="cta">
          <button
            onClick={() => {
              setShowAllId(id);
              id
                ? navigate(`/menu/category/${categoryId}/subcategory/${id}`)
                : navigate(`/menu/category/${categoryId}`);
            }}
          >
            <p>Виж повече продукти</p>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="8"
              viewBox="0 0 24 8"
              fill="none"
            >
              <path
                d="M17.333 4H0.999673"
                stroke="#343434"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M22.8092 3.78563L18.5448 1.22696C18.0115 0.907026 17.3332 1.29112 17.3332 1.91295V6.08705C17.3332 6.70888 18.0115 7.09297 18.5448 6.77304L22.8092 4.21437C22.971 4.11727 22.9711 3.88273 22.8092 3.78563Z"
                fill="#343434"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
}
